/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./OurStrength.css";

// IMPORT ICONS
import Icon1 from "../../Image/OurStrength/OurStrength1.png";
import Icon2 from "../../Image/OurStrength/OurStrength2.png";
import Icon3 from "../../Image/OurStrength/OurStrength3.png";
import Icon4 from "../../Image/OurStrength/OurStrength4.png";
import Icon5 from "../../Image/OurStrength/OurStrength5.png";
import Icon6 from "../../Image/OurStrength/OurStrength6.png";
import Icon7 from "../../Image/OurStrength/OurStrength7.png";
import Icon8 from "../../Image/OurStrength/OurStrength8.png";
import Icon9 from "../../Image/OurStrength/OurStrength9.png";



const services = [
  { icon: Icon1, title: "GST Department Award Winner (3 years in a row)", desc: "Recognized for excellence in tax compliance and contribution" },
  { icon: Icon2, title: "100% statutory compliance in ESI, PF, labour laws, minimum wages", desc: "Complete adherence to all labour regulations and standards" },
  { icon: Icon3, title: "100% police verified manpower", desc: "Strict ESI, PF, minimum-wage & labour law compliance" },
  { icon: Icon4, title: "Pan-India manpower pool & strong backend workforce management", desc: "Extensive network with efficient management systems" },
  { icon: Icon5, title: "Internal training programs + On-site SOPs", desc: "Continuous skill development and standardized procedures" },
  { icon: Icon6, title: "Structured audits & quality scoring", desc: "Regular quality checks and performance monitoring" },
{ icon: Icon7, title: "Low attrition with strong employee retention programs", desc: "Stable workforce through employee welfare initiatives" },
{ icon: Icon8, title: "Customised multi-service FM packages", desc: "Tailored solutions to meet specific client needs" },
{ icon: Icon9, title: "Tech enabled workplace", desc: "Modern technology integration for efficient operations" },
];

export default function OurStrengths() {
  return (
    <section className="services-section">
      {/* HEADER */}
      <div className="services-header">
       
        <h2>Our Strengths</h2>
        <p>What makes us the preferred FM partner</p>
      </div>

      {/* SERVICES GRID */}
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">
              <img src={service.icon} alt={service.title} />
            </div>
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          
          </div>
        ))}
      </div>
    </section>
  );
}
